import {Outlet, createFileRoute} from '@tanstack/react-router'
import {ReactNode, Suspense} from 'react'
import {promotionsQueryOptions} from '~/client/fn/promotions'
import StarField from '~/components/starfield/StarField'
import Navigation from '~/components/Navigation'
import NotFound from '~/components/NotFound'
import Footer from '~/components/Footer'
import Error from '~/components/Error'

export const Route = createFileRoute('/$lang/_layout')({
    component: LayoutComponent,
    loader: async ({context}) => {
        context.queryClient.ensureQueryData(promotionsQueryOptions(context.locale))
    },
    shouldReload: false,
    notFoundComponent: NotFoundComponent,
    errorComponent: ErrorComponent,
})

function LayoutComponent() {
    return (
        <Layout>
            <Outlet />
        </Layout>
    )
}

function NotFoundComponent() {
    return (
        <Layout>
            <NotFound />
        </Layout>
    )
}

function ErrorComponent() {
    return (
        <Layout>
            <Error />
        </Layout>
    )
}

export function Layout({children}: {children: ReactNode}) {
    return (
        <>
            <StarField />
            <Navigation />
            <main className="min-h-screen">
                <Suspense>{children}</Suspense>
            </main>
            <Suspense>
                <Footer />
            </Suspense>
        </>
    )
}
